import { defineStore } from 'pinia'

interface SnackbarOpts {
  showCloseButton?: boolean
  action?: {
    text: {
      success?: string
      error?: string
    }
    onActionSuccess?: () => void | null
    onActionError?: () => void | null
  }
}

interface ISnackbar {
  id: string
  show: boolean
  text: string
  color: string
  timeout: number
  opts?: SnackbarOpts
  icon?: string
}

interface RootStoreState {
  snackbars?: ISnackbar[]
  showFullscreenLoader: boolean
  fullScreenLoadingText?: string
  showSupportDialog?: boolean
}

export const useRootStore = defineStore('root', {
  state: (): RootStoreState => ({
    snackbars: [],
    showFullscreenLoader: false,
    fullScreenLoadingText: undefined,
    showSupportDialog: false,
  }),
  actions: {
    showSnackbar(
      text: string,
      color?: 'success' | 'info' | 'error' | 'primary' | 'secondary',
      timeout?: number,
      opts?: SnackbarOpts,
    ) {
      const snackbar: ISnackbar = {
        id: `snackbar-${color}-${this.snackbars?.length ?? 0}`,
        show: true,
        text,
        color: color ?? 'info',
        timeout: timeout ?? 4000,
        opts,
      }
      if (color === 'error') {
        snackbar.icon = 'mdi-alert-circle'
      } else if (color === 'success') {
        snackbar.icon = 'mdi-check-circle'
      } else {
        snackbar.icon = 'mdi-information'
      }
      if (this.snackbars?.length && this.snackbars?.length > 2) {
        this.snackbars = this.snackbars.slice(1)
      }
      this.snackbars?.push(snackbar)
    },
    handleAPIException(error: any, alternateMessage?: string) {
      this.showSnackbar(
        error?.response?.data?.error?.[0] ||
          error?.response?.data?.data?.message ||
          error?.response?.data?.message ||
          alternateMessage ||
          'An error occurred',
        'error',
        6000,
      )
    },
    showFullscreenLoaderWithText(text?: string) {
      this.showFullscreenLoader = true
      this.fullScreenLoadingText = text
    },
    clearFullscreenLoaderWithText() {
      this.showFullscreenLoader = false
      this.fullScreenLoadingText = undefined
    },
    openSupportDialog() {
      this.showSupportDialog = true
    },
    closeSupportDialog() {
      this.showSupportDialog = false
    },
  },
})
